import { render, staticRenderFns } from "./Gantt.vue?vue&type=template&id=6bfadad3&scoped=true&"
import script from "./Gantt.vue?vue&type=script&lang=js&"
export * from "./Gantt.vue?vue&type=script&lang=js&"
import style0 from "./Gantt.vue?vue&type=style&index=0&id=6bfadad3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfadad3",
  null
  
)

export default component.exports